import { render, staticRenderFns } from "./SecaoInclusaoDigital.vue?vue&type=template&id=703f6680&scoped=true"
import script from "./SecaoInclusaoDigital.vue?vue&type=script&lang=js"
export * from "./SecaoInclusaoDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f6680",
  null
  
)

export default component.exports